import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';

import Moment from 'react-moment';

import SpinnerComponent from '../Common/Spinners';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 15em;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: ${props => (props.view === 'player' && props.type === 'upcoming')
    ? '8em'
    : props.view === 'all'
      ? '30em'
      : '20em'
  };
  overflow-y: scroll;

  & :last-child {
    border-bottom: none;
  }
`

const MatchContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: .2em 0 .3em 0;
  border-bottom: 1px dashed #ccc;
  ${props => props.$hovered && 'background: #ccc;'}
`

const MatchContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 0.5em;
  height: 2.5em;

  & a {
    color: black;
  }
`

const Row1 = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  align-items: center;
`

const Team1 = styled.div`
  flex: 1;
  text-align: left;
`

const Team2 = styled.div`
  flex: 1;
  text-align: right;
`

const Versus = styled.div`
  font-size: .8em;
`

const MatchScoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: spread-evenly;
  width: 3em;
`

const MatchScoreWins = styled.div`
  flex: 1;
  text-align: ${props => props.align};
`

const TeamTagAndLogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.side === 'right' ? 'flex-end' : 'flex-start'};
  align-items: center;
  color: black;
`

const TeamTag = styled.div`
  width: 3em;
  overflow-x: hidden;
  overflow-y: hidden;
`

const TeamLogo = styled.img`
  max-width: 1.5em;
  margin: 0 .3em;
`

const PopoverWrapper = styled(Popover.Body)`
  color: black;
`

const Row2 = styled.div`
  display: flex;
  flex-direction: row;
  font-style: italic;
  font-size: .7rem;
`

const League = styled.div`
  flex: 1;
  color: #D86B22;
  width: 3em;
  text-align: right;
`

const MatchDatetime = styled.div`
  flex: 1;
  width: 10em;
`

const SeriesType = styled.div`
  text-align: center;
`

const NoMatches = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
  font-size: .75em;
  font-style: italic;
`

const Match = ({ match, type }) => {
  const seriesTypeMap = {
    'bestOf1': 'Bo1',
    'bestOf3': 'Bo3',
    'bestOf5': 'Bo5',
  }

  const [hovered, setHovered] = useState(false);

  if (match.leagueName?.indexOf('Game Changers') !== -1) {
    match.leagueName = match.leagueName.replace('Game Changers', 'GC');
  }

  if (match.leagueName?.indexOf('Challengers') !== -1) {
    match.leagueName = match.leagueName.replace('Challengers', 'Chall.');
  }

  return (
    <MatchContainer
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      $hovered={hovered}
    >
      <MatchContentContainer>
        <Row1>
          <Team1>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              delay={{ show: 100, hide: 200 }}
              key={match.team1Name}
              placement='top'
              overlay={
                <Popover id={`popover-${match.team1Name}`}>
                  <PopoverWrapper>
                    {match.team1Name || 'To Be Determined'}
                  </PopoverWrapper>
                </Popover>
              }
            >
              <TeamTagAndLogoContainer side='left'>
                {match.team1Code ? (
                  match.team1Id ? (
                    <>
                      <TeamTag>{match.team1Code}</TeamTag>
                      {match.team1Logo && match.team1Logo !== 'null' && match.team1Logo.substr(match.team1Logo.length - 4) !== ".svg" && (
                        <TeamLogo
                          src={match.team1Logo}
                          alt={`Team logo for ${match.team1Name}`}
                        />
                      )}
                    </>
                  ) : (
                    <span>{match.team1Code}</span>
                  )
                ) : (
                  'TBD'
                )}
              </TeamTagAndLogoContainer>
            </OverlayTrigger>
          </Team1>
          {type === 'upcoming' ? (
            <Versus>vs.</Versus>
          ) : (type === 'recent' || type === 'inProgress') ? (
            <MatchScoreContainer>
              <MatchScoreWins align='left'>{match.team1Wins}</MatchScoreWins>
              -
              <MatchScoreWins align='right'>{match.team2Wins}</MatchScoreWins>
            </MatchScoreContainer>
          ) : (
            <Versus>vs.</Versus>
          )}
          <Team2>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              delay={{ show: 100, hide: 200 }}
              key={match.team2Name}
              placement='top'
              overlay={
                <Popover id={`popover-${match.team2Name}`}>
                  <PopoverWrapper>
                    {match.team2Name || 'To Be Determined'}
                  </PopoverWrapper>
                </Popover>
              }
            >
              <TeamTagAndLogoContainer side='right'>
                {match.team2Code ? (
                  match.team2Id ? (
                    <>
                      {match.team2Logo && match.team2Logo !== 'null' && match.team2Logo.substr(match.team2Logo.length - 4) !== ".svg" && (
                        <TeamLogo
                          src={match.team2Logo}
                          alt={`Team logo for ${match.team2Name}`}
                        />
                      )}
                      <TeamTag>{match.team2Code}</TeamTag>
                    </>
                  ) : (
                    <span>{match.team2Code}</span>
                  )
                ) : (
                  'TBD'
                )}
              </TeamTagAndLogoContainer>
            </OverlayTrigger>
          </Team2>
        </Row1>
        <Row2>
          <MatchDatetime>
            <Moment
              date={match.startTime}
              format="MMM D, 'YY h:mm A"
            />
          </MatchDatetime>
          <SeriesType>
            {seriesTypeMap[match.seriesType]}
          </SeriesType>
          <League>
            {match.leagueName}
          </League>
        </Row2>
      </MatchContentContainer>
    </MatchContainer >
  );
};

const MatchList = ({ AppStore, view, type, matchList, allFetched, fetching }) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  const typeLabel = type === 'inProgress' ? 'in-progress' : type;

  useEffect(() => {

  }, [
    AppStore,
    matchList
  ]);

  return (
    ((view === 'all' && !allFetched) || fetching) ? (
      <SpinnerWrapper>
        <SpinnerComponent />
      </SpinnerWrapper>
    ) : (
      <Wrapper view={view} type={type}>
        {(matchList && matchList.length > 0) ? (
          matchList.map((match, idx) => {
            return (
              <Match
                idx={idx}
                match={match}
                key={`${match.seriesId}`}
                type={type}
              />
            )
          })
        ) : (
          <NoMatches>
            No {typeLabel} matches
          </NoMatches>
        )}
      </Wrapper>
    )
  );
};

export default inject('AppStore')(observer(MatchList))